// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kd-button__btn{font-size:.32rem;outline:none;border:0;width:100%;height:.8rem;align-items:center;align-content:center;display:flex;justify-content:center;position:relative}.kd-button__btn-primary{background:linear-gradient(138deg,#ffea4d,#ffdd1c);color:#141414;font-weight:700}.kd-button__btn-round{border-radius:.4rem}.kd-button__btn-disabled{width:100%;height:.8rem;position:absolute;left:0;top:0;background:hsla(0,0%,100%,.64)}", ""]);
// Exports
module.exports = exports;
